import { NgModule } from '@angular/core';
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppGuardService } from './app.guard.service';
import { InitialDataResolver } from './app.resolvers';
import { LandingComponent } from './discoverer/app-core/gateway-auth/landing/landing.component';
import { LayoutComponent } from './discoverer/app-core/layout/layout.component';
import { HomeComponent } from './home/home-admin/home.component';
import { DrillOutCustomerHomeComponent } from './home/drill-out-customer/drill-out-customer-home-component';
import { RoleBasedHomeGuard } from './app.home.guard';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
    { path: 'auth/landing', component: LandingComponent },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        data: {
            layout: 'futuristic'
        },
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent, canActivate: [RoleBasedHomeGuard] },
            { path: 'customer-home', component: DrillOutCustomerHomeComponent, canActivate: [RoleBasedHomeGuard] },
            { path: 'vchems-bol', loadChildren: () => import('./vchems-bol/vchems-bol.module').then(m => m.VCHEMSBOLModule), canActivate: [AppGuardService] },
            { path: 'vchems-bol', outlet: 'dialog', loadChildren: () => import('./vchems-bol/vchems-bol.module').then(m => m.VCHEMSBOLModule), canActivate: [AppGuardService] },
            {
                path: 'chofcd',
                loadChildren: () => import('./chain-of-custudy/ch.module').then(m => m.ChModule),
                canActivate: [RoleBasedHomeGuard]
            },
            { path: 'chofcd', outlet: 'dialog', loadChildren: () => import('./chain-of-custudy/ch.module').then(m => m.ChModule), canActivate: [AppGuardService] },

            {
                path: 'drill-out',
                loadChildren: () => import('./drill-out/drillout.module').then(m => m.DrillOutModule),
                canActivate: [AppGuardService]
            },
            { path: 'drill-out', outlet: 'dialog', loadChildren: () => import('./drill-out/drillout.module').then(m => m.DrillOutModule), canActivate: [AppGuardService] },

            { path: '**', redirectTo: 'home' }
        ]
    }
];

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    useHash: false,
    relativeLinkResolution: 'legacy'
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerConfig)],
    exports: [RouterModule],
    providers: [AppGuardService]
})
export class AppRoutingModule {
}
